import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const userSlice = createSlice({
    name: 'user',
    initialState: {
        user: {},
        service: {},
        wedding: {},
        refreshDataUserService: false,
        updateOrDeleteRefresh: false,
        isLoggedIn: false,
        isAuthLoading: true,
    },
    reducers: {
        loggedUser: (state, action) => {
            state.user = action.payload;
            state.isLoggedIn = true;
            state.isAuthLoading = false;
        },
        restoreUser: (state, action) => {
            state.user = action.payload;
            state.isLoggedIn = true;
            state.isAuthLoading = false;
        },
        loggOutUser: (state, action) => {
            state.user = {};
            state.isLoggedIn = false;
            state.isAuthLoading = false;
            state.service = {};
            state.wedding = {};
            Cookies.remove('authToken');
        },
        loggOutUserChangePassword: (state, action) => {
            state.user = {};
            state.isLoggedIn = false;
            state.isAuthLoading = false;
            state.service = {};
            state.wedding = {};
            Cookies.remove('authToken');
        },

        loggedService: (state, action) => {
            state.service = action.payload;
        },

        loggedWedding: (state, action) => {
            state.wedding = action.payload;
        },

        setAuthLoading: (state, action) => {
            state.isAuthLoading = action.payload;
        },
        refreshDataUserService: (state, action) => {
            state.refreshDataUserService = !state.refreshDataUserService;
        },
        updateOrDeleteRefresh: (state, action) => {
            state.updateOrDeleteRefresh = !state.updateOrDeleteRefresh;
        },
    },
});

export const { loggedUser, restoreUser, loggOutUser, loggOutUserChangePassword, setAuthLoading, loggedService, loggedWedding, refreshDataUserService, updateOrDeleteRefresh } =
    userSlice.actions;
export default userSlice.reducer;
